import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getPaymentMethods } from 'modules/settings/api';

export const useQueryPaymentMethods = () =>
  useQuery(QUERY_KEYS.SETTINGS_PROFILE_PAYMENT_METHODS, getPaymentMethods, {
    keepPreviousData: true,
    staleTime: 5 * 60 * 1000,
  });
